import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { ErrorText } from 'pages/login/styles';
import React, { useEffect, useRef, useState } from 'react';
import NewTextField, { NewTextFieldProps } from './NewTextField';

const Password = ({
  errorMessage,
  helperText,
  ...rest
}: NewTextFieldProps & { errorMessage?: string; helperText?: string }) => {
  const displayMessage = errorMessage || helperText;

  const [showPassword, setShowPassword] = useState(false);
  const [visibleError, setVisibleError] = useState<string | null>(null);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    if (displayMessage) {
      debounceTimeout.current = setTimeout(() => {
        setVisibleError(displayMessage);
      }, 350);
    } else {
      setVisibleError(null);
    }

    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [displayMessage]);

  return (
    <div>
      <NewTextField
        label="Password"
        inputProps={{
          type: showPassword ? 'text' : 'password',
          autoComplete: 'current-password',
        }}
        iconRight={showPassword ? faEye : faEyeSlash}
        onIconRightClick={handleClickShowPassword}
        {...rest}
      />
      {visibleError && (
        <ErrorText aria-live="polite" aria-atomic="true" role="alert">
          {visibleError}
        </ErrorText>
      )}
    </div>
  );
};

export default Password;
